import {
	ADD_COMMITTEE_MEMBER,
    GET_COMMITTEE_MEMBERS,
	DELETE_COMMITTEE_MEMBER,
	GET_POSITIONS_BYGROUP
} from '../../Actions/Admin/ManageCommitteeMemberAction';

const initialState = {
	committeeMembers: [],
	positionsByGroup:[]
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_COMMITTEE_MEMBERS:
			return {
				...state,
				committeeMembers: action.payload,
				loading: false
			};
		case ADD_COMMITTEE_MEMBER:
			return {
				...state,
				committeeMembers: action.payload
			};
		case DELETE_COMMITTEE_MEMBER:
			return {
				...state,
				committeeMembers: action.payload
			};
		case GET_POSITIONS_BYGROUP:
			return {
				...state,
				positionsByGroup: action.payload
			};
	
		default:
			return state;
	}
};
